export const data ={
    experience: [
        {
            title:"Associate Engineer I",
            subTitle: " SLK Software, Bengaluru, India",
            description:
            " User Experience, Visual Design , Frontend",
        },
        {
            title:"Associate Engineer II",
            subTitle:" SLK Software, Bengaluru, India",
            description:
               "Web Development, Database,Backend Development",
        },
    ],
    education: [
        {
            title:"Secondary (10th Grade)",
            subTitle:"Poorna Prajna Education Centre",
            description:
             "Scored 80.3% ",
        },
        {
            title:"Higher Secondary (12th Grade (PCME))",
            subTitle:"Shri Chaitanya PU College",
            description:
              "Scored 77%",
        },
        {
            title: " Bachelor of Technology (Electronics & communications)",
            subTitle: "Presidency University",
            description:
              " Scored 7.08 Cgpa", 
        },
    ],
};
